(function () {
  function initStickyCheckout() {
    var stickyWrap = document.getElementById('sticky-checkout');
    if (!stickyWrap) return;

    var stickyBtn = stickyWrap.querySelector('.sticky-checkout__btn');
    if (!stickyBtn) return;

    function getCheckoutBtn() {
      // solo el botón real del footer del carrito (tu id="checkout")
      return document.getElementById('checkout');
    }

    function isVisible(el) {
      if (!el || el.offsetParent === null) return false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return (r.top < vh && r.bottom > 0);
    }

    function update() {
      var checkoutBtn = getCheckoutBtn();
      if (!checkoutBtn) return;

      // click del sticky -> click del botón real
      stickyBtn.onclick = function () {
        if (checkoutBtn.hasAttribute('disabled')) return;
        checkoutBtn.click();
      };

      var scrolledEnough = window.scrollY > 300; // 👈 ajusta: 80, 120, 160
      var checkoutVisible = isVisible(checkoutBtn);

      // SOLO aparece si ya bajaste y el botón normal no se ve
      if (scrolledEnough && !checkoutVisible) {
        stickyWrap.classList.add('is-visible');
        stickyWrap.setAttribute('aria-hidden', 'false');
      } else {
        stickyWrap.classList.remove('is-visible');
        stickyWrap.setAttribute('aria-hidden', 'true');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 250);
    setTimeout(update, 900);
  }

  document.addEventListener('DOMContentLoaded', initStickyCheckout);
  setTimeout(initStickyCheckout, 900);
})();